import React from "react";
import { Modal, Button, Row, Col, Image, Badge } from "react-bootstrap";
import { convertIntoLakh } from "../Utilities";
import { CommaSeprator } from "../UtilityComponent/UtilityFunction";

const PlanDetailsPopup = ({ show, handleClose, QuotesData, QuoteReq, BuyNow }) => {

    console.log(QuotesData, QuoteReq, "QuotesData, QuoteReq")
    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton className="userFormModalHeader pb-3 pt-3">
                <Modal.Title>Plan Details</Modal.Title>
            </Modal.Header>
            <Modal.Body className="userFormModalHeader">
                <Row>
                    <Col md={8} className="border-end">
                        <div className="bg-light p-3 mt-3 rounded">
                            <p className="mb-1"><strong>Policy:</strong> {QuotesData.PlanName}</p>
                            <p className="mb-1"><strong>Covered Amount:</strong> {convertIntoLakh(QuotesData.SumInsured)}</p>
                            <p className="mb-1"><strong>Profession:</strong> {QuoteReq?.Occupation}</p>
                            <p className="mb-1"><strong>Specialization:</strong>{QuoteReq?.TypeofSpecializationLabel}</p>
                        </div>
                    </Col>

                    <Col md={4} className="text-center">
                        <Image
                            src={QuotesData.LogoURL}
                            alt="United India Insurance"
                            fluid
                            className="mb-3"
                            style={{ maxHeight: "80px" }}
                        />


                        <div className="bg-light p-3 Indemni_Premiu rounded text-start">
                            <Row className="mb-2">
                                <Col xs={7}><strong>Net Premium</strong></Col>
                                <Col xs={5} className="text-end">₹ {CommaSeprator(Math.round(QuotesData.NetPremium))}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={7}><span>+ GST (18%)</span></Col>
                                <Col xs={5} className="text-end">₹{CommaSeprator(Math.round(QuotesData.ServiceTax))}</Col>
                            </Row>
                            <hr className="my-2" />
                            <Row className="mb-3">
                                <Col xs={7}><strong>Total Premium</strong></Col>
                                <Col xs={5} className="text-end fw-bold text-dark">₹{CommaSeprator(Math.round(QuotesData.TotalPremium))}</Col>
                            </Row>
                            <div className="IPremium text-center">
                                <Button className="QuotNBtn btn-block" onClick={BuyNow}>₹{CommaSeprator(Math.round(QuotesData.TotalPremium))} <i class="fas fa-chevron-right"></i></Button>
                            </div>  
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default PlanDetailsPopup;
